import IAction from "../models/IAction";
import { Reducer, UnknownAction } from "redux";
import { isIAction } from "./ReduxUtility";

type ReducerMethod<T> = (state: T, action: IAction<any>) => T;
type ReducerMethods<T> = { [actionType: string]: ReducerMethod<T> };

const baseReducer = <T = any>(initialState: T, methods: ReducerMethods<T>): Reducer<T, UnknownAction> => {
  return (state: T = initialState, action: UnknownAction): T => {
    // Check if the action is an IAction
    if (!isIAction(action)) {
      return state;
    }

    const iAction = action as IAction<any>;

    // if the action type is used for a method name then this be a reference to
    // that class method.
    // if the action type is not found then the "method" const will be undefined.
    const method: ReducerMethod<T> | undefined = methods[iAction.type];

    // if the action type "method" const is undefined or the action is an error
    // return the state.
    if (!method || iAction.error) {
      return state;
    }

    return method(state, iAction);
  };
};

export default baseReducer;
